module.exports = __webpack_public_path__ + "static/media/instagram-logo.3ffc7032.svg";